export default __webpack_public_path__ + "static/media/Exaltate's Jerkin.7cf85237.jpg";